export const wphkDesignName = 'wphk-design';

